import { useMutation } from '@tanstack/react-query';

/**
 * Generic hook for Excel export functionality using React Query useMutation.
 *
 * @template T - Type of data to export
 * @param generateExcelFile - Function that takes data and returns a Promise (handles file generation & download)
 *
 * @returns Object with exportToExcel, exporting state, error handling, and reset
 */
export function useExcelExport<T>(
  generateExcelFile: (data: T) => Promise<void>
) {
  const mutation = useMutation({
    mutationFn: async (data: T) => {
      await generateExcelFile(data);
    },
  });

  return {
    exportToExcel: mutation.mutateAsync,
    exporting: mutation.isPending,
    exportError: mutation.error ? (mutation.error as Error).message : null,
    clearExportError: mutation.reset,
  };
}
